import { LINKS } from '@silo/types';
import { ExternalLink } from '@silo/ui';
import { FC } from 'react';

export const CurveLpMessage: FC = () => {
  return (
    <div className="flex flex-col gap-5 text-shale-200">
      <p className="text-lg font-medium ">Curve LP tokens deposit:</p>

      <ul className="list-disc flex flex-col gap-2.5 text-sm">
        <li className="ml-5">Deposit cannot be borrowed out.</li>
        <li className="ml-5">We automatically stake Curve LP tokens in Convex.</li>
        <li className="ml-5">Borrow ETH/XAI to leverage up.</li>
        <li className="ml-5">Earn all Curve/Convex rewards and boost.</li>
        <li className="ml-5">Withdraw anytime - you are in control.</li>
      </ul>

      <div className="flex mb-5">
        <p className="p-2.5 text-sm rounded-lg bg-amber-300/5 text-amber-300">
          Depositing Curve LP tokens costs ~3 times more gas than a regular deposit to pay for four bundled
          transactions. <ExternalLink href={LINKS.SILOPEDIA.BORROW_CURVE_LP} size="small" className="inline-block" />
        </p>
      </div>
    </div>
  );
};
